import React from "react";
import { FlexContainer } from "../../constants/assets/containers";
import PaginatedReactDropdown from "../../components/Common/PaginatedReactDropdown";
import Input from "sushiweb/InputTypes/Input";
import Button from "sushiweb/Button";
import { isValNull } from "../../utils";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as OrderPayoutAction from "../../store/actions/OrderPayout";
import * as UserActions from "../../store/actions/User";
import OrderPayoutDetailCard from "../../components/OrderPayout/index.js";
import BlankState from "../../components/Common/BlankState";
import { useHistory, useParams, Redirect } from "react-router-dom";
import { getPath } from "../../utils";

const FilterTypes = [
  { key: "order_id", label: "Order ID" },
  { key: "trip_id", label: "Trip ID" },
];

const BusinessTypes = [
  { key: "zomato", label: "Zomato" },
  { key: "blinkit", label: "Blinkit" },
  { key: "hyperpure", label: "Hyperpure"},
  { key: "other", label : "Other"}
];


const OrderPayout = (props) => {
  const { getOrderDetails, orderDetails, setStatus, setSideBarCollapsed } =
    props;
  const history = useHistory();
  const params = useParams();
  const filterType = getPath(params, "filter_type", undefined);
  const filterValue = getPath(params, "filter_value", undefined);
  const businessType = getPath(params, "business_type", undefined);

  const [initialState, setInitialState] = React.useState({
    filterType: "order_id",
    filterValue: "",
    businessType: "zomato",
  });

  const handleChange = (key, value) => {
    setInitialState((prevState) => {
      return { ...prevState, [key]: value };
    });
  };

  React.useEffect(() => {
    if (filterType && filterValue) {
      if (!businessType) {
        history.replace(`/order-payout/zomato/${filterType}/${filterValue}`);
        return;
      }
      setInitialState({
        filterType: filterType,
        filterValue: filterValue,
        businessType: businessType
      });
      getOrderDetails(filterType, filterValue,businessType);
    }
    setSideBarCollapsed(true);
  }, []);

  const handleSubmit = () => {
    if (!initialState.filterValue) {
      if (initialState.filterType === "order_id") {
        setStatus({ type: "error", message: "Please Enter Order Id" });
        return;
      } else if (initialState.filterType === "trip_id") {
        setStatus({ type: "error", message: "Please Enter Trip Id" });
        return;
      } else {
        setStatus({ type: "error", message: "Please Enter Filter Id" });
        return;
      }
    }
    history.push(
      `/order-payout/${initialState.businessType}/${initialState.filterType}/${initialState.filterValue}`
    );
  };

  const getInputLabel = (val, options, fromKey, toKey, isNumber) => {
    const activeEle = options.find((item) => {
      return item[fromKey] === (isNumber ? parseInt(val) : val);
    });
    return !isValNull(activeEle) ? activeEle[toKey] : "";
  };

  return (
    <section>
      <form onSubmit={handleSubmit}>
        <FlexContainer className="mb-20" align="flex-start" justify={"center"}>

      <PaginatedReactDropdown
        options={BusinessTypes}
        data-testid="businessTypeDropDown"
        value={getInputLabel(
          initialState.businessType,
          BusinessTypes,
          "key",
          "label"
        )}
        labelWidth="35%"
        handleChange={handleChange}
        keyToChange="businessType"
        showCross={false}
        id="businessTypeDropDown"
        width={"15%"}
        labelKey="label"
        valueKey="key"
      />
      <PaginatedReactDropdown
        options={FilterTypes}
        data-testid="orderCategoryDropDown"
        value={getInputLabel(
          initialState.filterType,
          FilterTypes,
          "key",
          "label"
        )}
        labelWidth="35%"
        handleChange={handleChange}
        keyToChange="filterType"
        showCross={false}
        id="orderCategoryDropDown"
        width={"15%"}
        labelKey="label"
        valueKey="key"
      />

    <div style={{ width: "40%" }}>
      <Input
        value={initialState.filterValue}
        data-testid="orderPayoutInput"
        id="sushi-input"
        onChange={(e) => handleChange("filterValue", e)}
        width={"50%"}
      />
    </div>
          <Button
            data-testid="submitOrderPayoutButton"
            className="sushi-btn"
            onClick={handleSubmit}
          >
            Submit
          </Button>
        </FlexContainer>
      </form>

      {orderDetails.map((item, index) => (
        <OrderPayoutDetailCard data={item} />
      ))}
      {orderDetails.length === 0 && <BlankState />}
    </section>
  );
};

const mapStateToProps = (state) => {
  const { OrderPayout } = state;
  return {
    orderDetails: OrderPayout.orderDetails,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    getOrderDetails: bindActionCreators(
      OrderPayoutAction.getOrderDetails,
      dispatch
    ),
    setStatus: bindActionCreators(UserActions.setStatus, dispatch),
    setSideBarCollapsed: bindActionCreators(
      UserActions.setSideBarCollapsed,
      dispatch
    ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderPayout);
